import * as React from "react";
import {
  TextInput,
  NumberInput,
  ImageInput,
  ImageField,
  SimpleForm,
  Edit,
  required,
  minValue,
  BooleanInput,
  useTranslate,
} from "react-admin";
import { Card, CardContent, Box } from "@mui/material";
import { useWatch } from "react-hook-form";

const TitleInput = () => {
  const title = useWatch({ name: "title" });
  const translate = useTranslate();
  const currentLength = title?.length || 0;

  return (
    <TextInput
      source="title"
      validate={required()}
      helperText={translate('app.validation.charactersLimit', { current: currentLength, max: 100 })}
      fullWidth
    />
  );
};

const DescriptionInput = () => {
  const description = useWatch({ name: "description" });
  const translate = useTranslate();
  const currentLength = description?.length || 0;

  return (
    <TextInput
      source="description"
      multiline
      minRows={4}
      validate={required()}
      helperText={translate('app.validation.charactersLimit', { current: currentLength, max: 500 })}
      fullWidth
    />
  );
};

const transformTelegramProduct = (data: any) => {
  const out: any = { ...data };
  if (out.price !== undefined && out.price !== null && out.price !== "") {
    out.price = Number(out.price);
  }
  return out;
};

export const TelegramProductEdit: React.FC = () => {
  const translate = useTranslate();

  return (
    <Edit transform={transformTelegramProduct} redirect="list" mutationMode="pessimistic">
      <SimpleForm>
        <Box display="flex" gap={3} flexWrap="wrap">
          <Box flex={1} minWidth={280}>
            <TitleInput />
            <NumberInput
              source="price"
              label={translate('app.product.priceCZK')}
              validate={[required(), minValue(0)]}
              fullWidth
            />
            <DescriptionInput />
            <BooleanInput
              source="postedInTg"
              label={translate('app.telegram.postedInTelegram')}
              helperText={translate('app.telegram.toggleToPost')}
            />
          </Box>

          <Box flex={1} minWidth={280}>
            <Card variant="outlined">
              <CardContent>
                <Box mb={2}>
                  <strong>{translate('app.telegram.currentImage')}</strong>
                  <ImageField
                    source="image"
                    sx={{ "& img": { maxWidth: 260, borderRadius: 2, marginTop: 1 } }}
                  />
                </Box>

                <ImageInput source="image" label={translate('app.telegram.replaceImage')} accept="image/*" multiple={false}>
                  <ImageField
                    source="src"
                    title="title"
                    sx={{ "& img": { maxWidth: 260, borderRadius: 2 } }}
                  />
                </ImageInput>
              </CardContent>
            </Card>
          </Box>
        </Box>
      </SimpleForm>
    </Edit>
  );
};
